import { Injectable}   from "@angular/core";
import { Observable }  from "rxjs";
import { HttpClient }  from "@angular/common/http";

import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";

@Injectable()
export class ListaAtividadeAssuntoService {

    constructor(
        private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService
    ) {}

    /**
     * Tipo de Oportunidade por id
     * @param id ID da Tipo de Oportunidade
     */
    getById(id: number): Observable<any> {
        return this._http.get(
            this.utilitesService.urlPrefix + "lista-atividades/assunto/" + id, { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Tipo de Oportunidade
     * @param id ID da Tipo de Oportunidade
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(
            this.utilitesService.urlPrefix + "lista-atividades/assunto" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Tipo de Oportunidade
     */
    getLista(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }
        return this._http.get(
            this.utilitesService.urlPrefix + "lista-atividades/assunto/lista" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Delete de Tipo de Oportunidade
     * @param id ID da Tipo de Oportunidade
     */
    delete(id: number): Observable<any> {
        return this._http.delete(
            this.utilitesService.urlPrefix + "lista-atividades/assunto/" + id,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Cadastra Tipo de Oportunidade
     * @param params Json Tipo de Oportunidade
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "lista-atividades/assunto",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Tipo de Oportunidade
     * @param params Json Tipo de Oportunidade
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "lista-atividades/assunto/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
